

(function () {
  'use strict';
  var s = document.querySelector('[data-ws]');
  if (!s) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  s.classList.add('ws--vivo');
  var ets = [].slice.call(s.querySelectorAll('.ws__et'));
  var ll = s.querySelector('.ws__lleno');
  var ol = s.querySelector('[data-ws-linea]');
  var fotos = [].slice.call(s.querySelectorAll('[data-ws-foto]'));
  var raf = 0;
  function pinta() {
    raf = 0;
    var c = window.innerHeight * 0.55, act = -1;
    ets.forEach(function (e, i) { if (e.getBoundingClientRect().top < c) act = i; });
    ets.forEach(function (e, i) {
      e.classList.toggle('on', i === act);
      e.classList.toggle('pasada', i < act);
    });

    var f = Math.max(0, act);
    fotos.forEach(function (x, i) { x.classList.toggle('on', i === f); });
    var r = ol.getBoundingClientRect(), h = 0;
    if (act >= 0) {
      var e = ets[act].getBoundingClientRect();
      h = Math.max(0, Math.min(Math.min(e.bottom, c) - r.top - 12, r.height - 24));
    }
    ll.style.height = h + 'px';
  }
  function pedir() { if (!raf) raf = requestAnimationFrame(pinta); }
  addEventListener('scroll', pedir, { passive: true });
  addEventListener('resize', pedir);
  pinta();
})();
